var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"popwin-coin"},[_vm._l((9),function(i){return [_c('div',{key:i,class:['coin','coin'+i,{forwards:i===9}],style:({
        animationDelay:.07*i+_vm.delayTime +'s',
        transform: 'rotateZ('+_vm.rotateDeg +'deg)',
        backgroundPosition:-(i-1) *60 +'px 0'
      })})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }